import React from "react";

import { PositionsOrVirtualPortfolioPlanStats } from "@fartherfinance/frontend/api/Investment/request/postPositionsOrVirtualPortfolioPlanStats";

import NoDataSet from "@src/multiCustodian/components/Portfolios/NoDataSet";
import SimpleTwoColumnFlexBetweenTableRow from "@src/sharedComponents/SimpleTwoColumnFlexBetweenTableRow/Row";
import TextWithPerformance from "@src/sharedComponents/TextWithPerformance/TextWithPerformance";

interface Props {
  isLoading: boolean;
  hasError: boolean;
  data: PositionsOrVirtualPortfolioPlanStats | undefined;
}

const PortfolioHistoricalScenariosTable: React.FC<Props> = ({
  isLoading,
  hasError,
  data,
}) => {
  if (hasError === true) {
    return <NoDataSet text={"Error loading stats"} iconColor={"error"} />;
  }

  if (isLoading === false && data === undefined) {
    return <NoDataSet text={"Data set empty"} iconColor={"info"} />;
  }

  return (
    <React.Fragment>
      <SimpleTwoColumnFlexBetweenTableRow
        textStart={"Average Bull Market"}
        customEndText={
          <TextWithPerformance
            numberText={data?.data.scenarioStrongFb ?? undefined}
            isPercent={true}
          />
        }
      />

      <SimpleTwoColumnFlexBetweenTableRow
        textStart={"Average Normal Market"}
        customEndText={
          <TextWithPerformance
            numberText={data?.data.scenarioNormalFb ?? undefined}
            isPercent={true}
          />
        }
      />

      <SimpleTwoColumnFlexBetweenTableRow
        textStart={"Average Bear Market"}
        customEndText={
          <TextWithPerformance
            numberText={data?.data.scenarioWeakFb ?? undefined}
            isPercent={true}
          />
        }
      />

      <SimpleTwoColumnFlexBetweenTableRow
        textStart={"2000 Crash"}
        customEndText={
          <TextWithPerformance
            numberText={data?.data.scenarioCrash2000HybFb ?? undefined}
            isPercent={true}
          />
        }
      />

      <SimpleTwoColumnFlexBetweenTableRow
        textStart={"2008 Crash"}
        customEndText={
          <TextWithPerformance
            numberText={data?.data.scenarioCrash2008HybFb ?? undefined}
            isPercent={true}
          />
        }
      />

      <SimpleTwoColumnFlexBetweenTableRow
        textStart={"2020 Pandemic Crash"}
        customEndText={
          <TextWithPerformance
            numberText={data?.data.scenarioCovid2020HybFb ?? undefined}
            isPercent={true}
          />
        }
        hideBottomBorder={true}
      />
    </React.Fragment>
  );
};

export default PortfolioHistoricalScenariosTable;
